class BlinkDraw {
  constructor(lang, id, percent, name, blink, locale, twoMassRatio = 97) {
    if (id) {
      this._canvas = document.querySelector(id);
    } else {
      this._canvas = document.createElement("canvas");
    }
    if (percent < 0 || percent > 100) {
      return;
    }
    if (lang) {
      this.$t = lang;
      // console.log('this.$t', this.$t)
    }
    this._ctx = this._canvas.getContext("2d");
    this._canvas.width = this._canvas.width;
    this._canvas.height = this._canvas.height;
    this._size = {
      width: this._canvas.width / 2,
      height: this._canvas.height / 2
    };
    this.PI = Math.PI;
    this.name = name;
    this.locale = locale;
    this.blink = blink;
    this.oneMassRatio = blink;
    this.twoMassRatio = twoMassRatio;
    this._ctx.clearRect(0, 0, this._size.width * 2, this._size.height * 2);
    this.draw(this._ctx, percent, this.name);
  }
  // 获取字符串的真实长度（字节长度）
  getTrueLength(str) {
    let len = str.length,
      truelen = 0;
    for (let x = 0; x < len; x++) {
      if (str.charCodeAt(x) > 128) {
        truelen += 2;
      } else {
        truelen += 1;
      }
    }
    return truelen;
  }
  // 按字节长度截取字符串，返回substr截取位置
  cutString(str, leng) {
    let len = str.length,
      tlen = len,
      nlen = 0;
    for (let x = 0; x < len; x++) {
      if (str.charCodeAt(x) > 128) {
        if (nlen + 2 < leng) {
          nlen += 2;
        } else {
          tlen = x;
          break;
        }
      } else {
        if (nlen + 1 < leng) {
          nlen += 1;
        } else {
          tlen = x;
          break;
        }
      }
    }
    return tlen;
  }
  // ctx       getContext("2d") 对象
  // lineheight    段落文本行高
  // bytelength    设置单字节文字一行内的数量
  // color         段落文体颜色
  // fontsize      段落文体字体样式
  // text          写入画面的段落文本
  // startleft     开始绘制文本的 x 坐标位置（相对于画布）
  // starttop      开始绘制文本的 y 坐标位置（相对于画布）
  writeTextOnCanvas(ctx, lineheight, bytelength, color, fontsize, text, startleft, starttop) {
    for (let i = 1; this.getTrueLength(text) > 0; i++) {
      let tl = this.cutString(text, bytelength);
      ctx.fillStyle = color;
      ctx.font = fontsize;
      ctx.fillText(
        text.substr(0, tl).replace(/^s+|s+$/, ""),
        startleft,
        (i - 1) * lineheight + starttop
      );
      text = text.substr(tl);
    }
  }
  Drawtext(cxt, text, x, y, color, fontsize, multiple = 2, ycoordinate = 30) {
    // 因为需要使用到坐标平移, 所以在平移前线保存当前绘制状态
    cxt.save();
    x -= cxt.measureText(text).width * multiple; // 文字起点横坐标
    y -= ycoordinate; // 文字起点纵坐标
    cxt.beginPath(); // 开始创建路径
    cxt.translate(x, y); // 平移坐标
    cxt.fillStyle = color;
    cxt.font = fontsize;
    cxt.fillText(text, -10, 0); // 填充文字
    cxt.restore();
  }
  drawCanvas(cxt, x, y, r, sRadian, eRadian, color, lineWidth, incomplete = false) {
    cxt.beginPath();
    cxt.lineCap = incomplete ? "butt" : "round";
    cxt.strokeStyle = color;
    cxt.lineWidth = lineWidth;
    cxt.arc(x, y, r, sRadian, eRadian, true);
    cxt.stroke();
  }
  draw(cxt, percent, name, sR = 1 * Math.PI) {
    if (percent < 0 || percent > 100) {
      return;
    }

    // let finalRadian = sR + ((PI + (PI - 1/2 * Math.PI) * 2) * percent / 100); // 红圈的终点弧度
    let step = (this.PI + (this.PI - (1 / 2) * Math.PI) * 2) / 100; // 一个1%对应的弧度大小
    // cxt.clearRect(0, 0, this._size.width * 2, this._size.height * 2);

    // 眨眼占比弧渐变
    let endRadian = sR + percent * step;
    let angle = 2 * this.PI + endRadian; // 转换成逆时针方向的弧度（三角函数中的）
    // let colour = cxt.createLinearGradient(Math.cos(angle) * 100 + this._size.width, -Math.sin(angle) * 100 + this._size.height, sR, this._size.height);
    let leftDownColor = cxt.createLinearGradient(0, 150, 150, 300); // 左下渐变
    leftDownColor.addColorStop(0.0, "rgba(0, 0, 0, 0.3)");
    leftDownColor.addColorStop(0.6, "rgba(228, 25, 29, 1)");
    leftDownColor.addColorStop(1.0, "rgba(228, 25, 29, 1)");
    let rightDownColor = cxt.createLinearGradient(150, 250, 250, 150); // 右下渐变
    rightDownColor.addColorStop(0.0, "rgba(228, 25, 29, 1)");
    rightDownColor.addColorStop(0.5, "rgba(224, 70, 60, 1)");
    rightDownColor.addColorStop(1.0, "rgba(228, 97, 87, 1)");
    let rightUpColor = cxt.createLinearGradient(250, 150, 150, 50); // 右上渐变
    rightUpColor.addColorStop(0.0, "rgba(228, 97, 87, 1)");
    rightUpColor.addColorStop(0.15, "rgba(228, 97, 87, 1)");
    rightUpColor.addColorStop(0.5, "rgba(236, 188, 88, 1)");
    rightUpColor.addColorStop(0.8, "rgba(241, 212, 26, 1)");
    rightUpColor.addColorStop(0.9, "rgba(242, 229, 36, 1)");
    rightUpColor.addColorStop(1.0, "rgba(242, 229, 36, 1)");
    let leftUpColor = cxt.createLinearGradient(150, 100, 50, 150); // 左上渐变
    leftUpColor.addColorStop(0.0, "rgba(242, 229, 36, 1)");
    leftUpColor.addColorStop(0.1, "rgba(241, 212, 26, 1)");
    leftUpColor.addColorStop(0.3, "rgba(84, 177, 62, 1)");
    leftUpColor.addColorStop(0.5, "rgba(19, 164, 63, 1)");
    leftUpColor.addColorStop(0.7, "rgba(4, 156, 69, 1)");
    leftUpColor.addColorStop(1.0, "rgba(1, 154, 72, 1)");

    // 画完全眨眼占比圆弧
    // this.drawCanvas(cxt, this._size.width, this._size.height, 100, percent !== 0 ? -endRadian : endRadian, -sR, colour, 75, percent > 95 ? true : false);
    this.drawCanvas(
      cxt,
      this._size.width,
      this._size.height,
      100,
      1 * Math.PI,
      0.5 * Math.PI,
      leftDownColor,
      75,
      true
    ); // 左下扇形
    this.drawCanvas(
      cxt,
      this._size.width,
      this._size.height,
      100,
      1.5 * Math.PI,
      1 * Math.PI,
      leftUpColor,
      75,
      false
    ); //左上扇形
    this.drawCanvas(
      cxt,
      this._size.width,
      this._size.height,
      100,
      0.5 * Math.PI,
      0,
      rightDownColor,
      75,
      true
    ); // 右下扇形
    this.drawCanvas(
      cxt,
      this._size.width,
      this._size.height,
      100,
      0,
      1.5 * Math.PI,
      rightUpColor,
      75,
      true
    ); // 右上扇形

    // let linGrad = cxt.createLinearGradient(1 * Math.PI, this._size.height, Math.cos(angle) * 100 + this._size.width, -Math.sin(angle) * 100 + this._size.height);
    // if (percent > 18 && percent < 92) linGrad.addColorStop(0.0, 'rgba(44, 49, 55, 0)');
    // linGrad.addColorStop(0.8, 'rgba(219, 214, 58, 1)');
    // linGrad.addColorStop(1, 'rgba(219, 214, 58, 1)');
    // 画不完全眨眼占比圆弧
    // this.drawCanvas(cxt, this._size.width, this._size.height, 100, -sR, -endRadian, linGrad, 75, true);

    if (percent !== 0 && name === "proportion") {
      if (this.locale === "zh_CN") {
        // this.Drawtext(cxt,
        //   this.$t.txtProportionOfIncompleteBlinking,
        //   this._size.width,
        //   this._size.height,
        //   (percent > 20 && percent < 92) ?'#e2d1d7' : '#FFFFFF',
        //   'normal normal 11px Arial',
        //   this.locale === 'zh_CN' ? 1.3 : (this.locale === 'en_US' ? 0.9 : ''),
        //   -70)
      } else {
        // this.writeTextOnCanvas(this._ctx,
        //   10,
        //   this.locale === 'en_US' ? 18 : 15,
        //   (percent > 20 && percent < 92) ?'#e2d1d7' : '#FFFFFF',
        //   'normal normal 11px Arial',
        //   this.$t.txtProportionOfIncompleteBlinking,
        //   this.locale === 'en_US' ? 30 : 30,
        //   this.locale === 'en_US' ? 210 : 210)
      }
      // this.Drawtext(cxt,
      //   `${percent}%`,
      //   this._size.width,
      //   this._size.height,
      //   '#FFFFFF',
      //   'normal normal bold 22px Arial',
      //   percent !== 100 ? 3.8 : 3,
      //   -95)
    }
    if (percent !== 100 && name === "proportion") {
      if (this.locale === "zh_CN") {
        // this.Drawtext(cxt,
        //   this.$t.txtProportionOfCompleteBlinking,
        //   this._size.width,
        //   this._size.height,
        //   '#abf8c2',
        //   'normal normal 11px Arial',
        //   2.05,
        //   10)
        // this.Drawtext(cxt,
        //   `${100 - percent}%`,
        //   this._size.width,
        //   this._size.height,
        //   '#FFFFFF',
        //   'normal normal bold 22px Arial',
        //   percent !== 0 ? (percent > 90 ? 7 : 5.5) : 4.5,
        //   -15)
      } else {
        // this.writeTextOnCanvas(this._ctx,
        //   10,
        //   15,
        //   '#abf8c2',
        //   'normal normal 11px Arial',
        //   this.$t.txtProportionOfCompleteBlinking,
        //   (this.locale === 'en_US' || this.locale === 'de') ? 18 : 12,
        //   (this.locale === 'en_US' || this.locale === 'de') ? 120 : 140)
        // this.Drawtext(cxt,
        //   `${100 - percent}%`,
        //   this._size.width,
        //   this._size.height,
        //   '#FFFFFF',
        //   'normal normal bold 22px Arial',
        //   percent !== 0 ? (percent > 90 ? 7 : 5) : 4.5,
        //   -15)
      }
    }

    // 阴影
    cxt.shadowOffsetX = 2;
    cxt.shadowOffsetY = 2;
    cxt.shadowColor = "#333";
    cxt.shadowBlur = 20;
    // 画指针
    cxt.beginPath();
    cxt.strokeStyle = "#bdbed0";
    cxt.lineWidth = 8;
    cxt.moveTo(
      Math.cos(angle + 20) * 12 + this._size.width,
      -Math.sin(angle + 20) * 12 + this._size.height
    );
    cxt.lineTo(Math.cos(angle) * 80 + this._size.width, -Math.sin(angle) * 80 + this._size.height);
    cxt.lineTo(
      Math.cos(angle - 20) * 12 + this._size.width,
      -Math.sin(angle - 20) * 12 + this._size.height
    );
    cxt.closePath();
    cxt.stroke();

    // 画圆心
    this.drawCanvas(cxt, this._size.width, this._size.height, 30, 0, 2 * this.PI, "#000000", 70);
    // 圆心中间的字
    cxt.textAlign = "center";
    cxt.textBaseline = "middle";
    cxt.fillStyle = "#FFF";
    if (name === "proportion") {
      // cxt.font = 'normal normal bold 30px Arial';
      // cxt.fillText(`${this.blink}`, this._size.width, this._size.height - 10);
      // cxt.fillStyle = '#999';
      cxt.font = `normal normal ${this.locale === "de" ? "16px" : this.locale === "ja" ? "18px" : this.locale === "it" ? "11px" : "20px"} Arial`;
      cxt.fillText(
        this.locale === "de" ? this.$t.txtBlink : this.$t.txtBlinkQuality,
        this._size.width,
        this._size.height
      );
    } else {
      cxt.font = "normal normal bold 20px Arial";
      cxt.fillText(
        `${this.oneMassRatio}%-${this.twoMassRatio}%`,
        this._size.width,
        this._size.height - 10
      );
      cxt.fillStyle = "#999";
      cxt.font = "normal normal 14px Arial";
      cxt.fillText(
        this.locale === "de" ? this.$t.txtBlink : this.$t.txtBlinkQuality,
        this._size.width,
        this._size.height + 20
      );
    }
  }
}
export default BlinkDraw;



// WEBPACK FOOTER //
// ./src/dryeye/js/blinkdraw.js